import { DateInput, CurrencyInput } from '@components';
import { memo } from 'react';
import { nullIfEmpty } from '@utils/nullIfEmpty';
import { GlobalHeader, InputDiv, InputList, StyledInput } from '../styles';
import { PropsInputGlobal } from './types';
import { onChangeGlobal, setForAllNew } from './utils';

type PurchaseInformationGroupProps = PropsInputGlobal<
  'purchasedPrice' | 'purchasedFrom' | 'purchasedDate'
>;

export function PurchaseInformationGroup(props: PurchaseInformationGroupProps) {
  const { setFormV, purchasedDate, purchasedFrom, purchasedPrice } = props;
  const { setGlobalFormV } = props;

  return (
    <InputList className="three">
      <InputDiv>
        <GlobalHeader>Purchased Price</GlobalHeader>
        <CurrencyInput
          value={purchasedPrice ?? undefined}
          onChange={val => {
            const numberValue = val ?? null;
            onChangeGlobal('purchasedPrice', numberValue, setGlobalFormV);
            setForAllNew('purchasedPrice', numberValue, setFormV);
          }}
        />
      </InputDiv>
      <InputDiv>
        <GlobalHeader>Purchased From</GlobalHeader>
        <StyledInput
          value={purchasedFrom ?? ''}
          onChange={e => {
            const cleanValue = nullIfEmpty.setValueAs(e.target.value);
            onChangeGlobal('purchasedFrom', cleanValue, setGlobalFormV);
            setForAllNew('purchasedFrom', cleanValue, setFormV);
          }}
        />
      </InputDiv>
      <InputDiv>
        <GlobalHeader>Purchased Date</GlobalHeader>
        <DateInput
          borderColor="#d8dae5"
          value={purchasedDate ?? null}
          handleDateChange={e => {
            let convDate: Date | null = null;
            if (e) convDate = new Date(e);
            onChangeGlobal('purchasedDate', convDate, setGlobalFormV);
            setForAllNew('purchasedDate', convDate, setFormV);
          }}
        />
      </InputDiv>
    </InputList>
  );
}
export default memo(PurchaseInformationGroup);
